import React, { useState, useEffect, useRef } from "react";
import CountUp from "react-countup";

const Count = ({ counter }) => {
  const [isVisible, setIsVisible] = useState(false);
  const countRef = useRef(null);

  useEffect(() => {
    const element = countRef.current; // Store ref value in a variable

    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.5 } // Trigger when 50% of the element is visible
    );

    if (element) {
      observer.observe(element);
    }

    // Cleanup function uses the stored reference to avoid issues with stale refs
    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  return (
    <span ref={countRef} className="counter">
      {isVisible && <CountUp end={counter} />}
    </span>
  );
};

export default Count;
